"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DispatchModule = /** @class */ (function () {
    function DispatchModule() {
    }
    return DispatchModule;
}());
exports.DispatchModule = DispatchModule;
